/**
 * initCookies
 * Gerencia o banner de LGPD usando localStorage e BEM.
 */
export default function initCookies() {
    const cookieAlert = document.querySelector('.c-cookie');
    const acceptBtn = document.querySelector('.c-cookie__btn--accept');

    if (!cookieAlert || !acceptBtn) return;

    const COOKIE_STORAGE_KEY = 'pdr_cookies_accepted';

    const hideBanner = () => {
        cookieAlert.classList.remove('is-active');
        // Opcional: remover do DOM após a animação de saída do SCSS (ex: 500ms)
        setTimeout(() => {
            cookieAlert.setAttribute('aria-hidden', 'true');
            cookieAlert.style.display = 'none';
        }, 500);
    };

    const showBanner = () => {
        cookieAlert.classList.add('is-active');
        cookieAlert.setAttribute('aria-hidden', 'false');
    };

    // Verifica se já aceitou
    if (!localStorage.getItem(COOKIE_STORAGE_KEY)) {
        // Delay leve para não impactar LCP (Largest Contentful Paint)
        setTimeout(showBanner, 2000);
    } else {
        cookieAlert.style.display = 'none';
    }

    acceptBtn.addEventListener('click', (e) => {
        e.preventDefault();
        localStorage.setItem(COOKIE_STORAGE_KEY, 'true');
        hideBanner();
    });
}